module.exports = __webpack_public_path__ + "static/media/help-rule-5a.c38461af.gif";